<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-layout wrap>
      <v-flex pt-4 xs12>
        <v-layout wrap justify-center>
          <v-flex px-2 xs12 lg10 xl10>
            <Product
              v-if="loadData"
              v-bind:productData="productData"
              v-bind:pagination="pagination"
              v-bind:sorting="sortType"
              @stepper="winStepper"
              :key="productData[0]._id"
            />
          </v-flex>
          <v-flex py-4 xs12 text-center align-self-center>
            <v-pagination v-model="currentPage" :length="pages" :total-visible="7" color="#63028F" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Product from "./product";
export default {
  components: {
    Product,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      productData: {},
      loadData: false,
      totalData: 0,
      pages: 0,
      count: 60,
      currentPage: 1,
      sortType: null,
      pagination: {
        pages: 0,
        count: 0,
        startingcount: 0,
        endingcount: 0,
      },
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/bestseller",
        params: {
          count: this.count,
          page: this.currentPage,
          sort: this.sortType,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.productData = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
          this.pagination.pages = response.data.pages;
          this.pagination.count = response.data.count;
          this.pagination.startingcount = response.data.startingcount;
          this.pagination.endingcount = response.data.endingcount;
          this.loadData = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    winStepper(window_data) {
      this.currentPage = 1;
      this.sortType = window_data.sort;
      this.getData();
    },
  },
};
</script>